'use client';

import { useTranslations } from 'next-intl';
import { IconInfoCircle } from '@tabler/icons-react';
import { Badge } from '@/components/ui/badge';
import { Switch } from '@/components/ui/switch';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Link } from '@/i18n/routing';

export default function ContentFilteringControl({ kind = 'botgo', checked, onChange, trackClassName, tooltipClassName }) {
  const isSeedance = kind === 'seedance';
  const t = useTranslations(isSeedance ? 'GenerationStudio.privacySetting' : 'GenerationStudio.contentFiltering');
  const switchId = isSeedance ? 'seedance-content-filtering-switch' : 'no-content-filtering-switch';
  return (
    <div className="mt-3 border-t border-white/10 pt-3">
      <div className="mb-2 px-1 text-left text-[10px] font-semibold uppercase tracking-wider text-neutral-500">{t('title')}</div>
      <div className={`flex items-center justify-between gap-3 rounded-lg px-3 py-2 ${trackClassName}`}>
        <div className="flex min-w-0 items-center gap-1.5 text-xs text-white">
          <label htmlFor={switchId} className="cursor-pointer">{t('switch')}</label>
          {!isSeedance && <Badge variant="pro">PRO</Badge>}
          <TooltipProvider delayDuration={150}>
            <Tooltip>
              <TooltipTrigger asChild>
                <button type="button" aria-label={t('infoLabel')} className="shrink-0 text-neutral-400 transition hover:scale-105 hover:text-white">
                  <IconInfoCircle size={14} />
                </button>
              </TooltipTrigger>
              <TooltipContent data-generator-interactive-portal="true" side="top" className={`w-[min(26rem,calc(100vw-2rem))] whitespace-normal text-left text-xs leading-relaxed ${tooltipClassName}`}>
                {t.rich('info', { terms: chunks => <Link href="/terms-of-service" className="underline underline-offset-2">{chunks}</Link> })}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Switch
          id={switchId}
          checked={checked}
          onCheckedChange={onChange}
          aria-label={t('switch')}
          className="h-5 w-9 shrink-0 border-0 shadow-none transition hover:scale-105 data-[state=checked]:bg-amber-500 data-[state=unchecked]:bg-neutral-600 [&>span]:h-4 [&>span]:w-4 [&>span]:bg-white [&>span]:data-[state=checked]:translate-x-4 [&>span]:data-[state=unchecked]:translate-x-0"
        />
      </div>
    </div>
  );
}
